import "../../css/prices.css";
import Navbar from "../../components/navigation/Navbar";
import Footer from "../../components/global/Footer";
import Products from "./Products";

function Prices() {


  return (
    <div>
      <Navbar />
      <Products />
      <Footer />
    </div>
  );
}
export default Prices;
